import { render, staticRenderFns } from "./TextLoader.vue?vue&type=template&id=15a94400&"
import script from "./TextLoader.vue?vue&type=script&lang=js&"
export * from "./TextLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TextLoader.vue"
export default component.exports